"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../constants");
var paths = {
    LOCATION_FETCH: '/location/info',
    SWAP_ASSETS: '/swap/assets',
    SWAP_ORDER: '/swap/order',
    SWAP_ORDER_HISTORY: '/swap/order_history',
    SWAP_ORDER_SAVE: '/swap/order/save',
    SWAP_QUOTE: '/swap/quote',
    SWAP_RATE: '/swap/rate',
    WALLET_FETCH: '/wallet',
    WALLET_GET_ADDRESS: '/wallet/address',
    MARKETS_HISTORIC: '/markets/historic',
    SIGN_URL: '/sign',
    V2_AUTH_LOGIN: '/auth/authorize',
    V2_AUTH_LOGOUT: '/auth/logout',
    V2_BLOCKS: '/blocks',
    V2_SUMSUB_RETRIEVE_ACCESS_TOKENS: '/kyc/sumsub/retrieve-access-token',
    V2_USER_DETAILS: '/user/user-details',
    V2_VERSE_TRANSACTION: '/verse/transaction',
    V2_VERSE_MERKLE_PROOF: '/verse/proof',
    V2_STAKING: '/stakings',
    V2_FARM: '/farms'
};
var endpoints = {};
Object.keys(paths).forEach(function (key) {
    if (key.startsWith('V2'))
        endpoints[key] = constants_1.API_V2_URL + paths[key];
    else
        endpoints[key] = constants_1.API_URL + paths[key];
});
exports.default = endpoints;
